import React, {useState} from 'react';
import {
    FunctionField,
    RichTextField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField,
    TextInput,
    useRedirect
} from 'react-admin';
import {makeStyles} from "@material-ui/core/styles";
import GradientButton from "../../../Component/Layouts/Button/GradientButton";
import {convertedDateWithTime} from "../../../Functions/ConvertedDate";
import {Typography} from "@mui/material";
import {useRecordContext} from "react-admin";

// Mirrors the parameters the backend catalogue marks as supported, so the shown
// settings are exactly the ones actually sent to the API.
const MODEL_FIELDS = [
    {param: 'reasoning_effort', label: 'Effort:', source: 'effort'},
    {param: 'verbosity', label: 'Verbosity:', source: 'verbosity'},
    {param: 'top_p', label: 'Top P (0.0 - 1.0):', source: 'top_p'},
    {param: 'temperature', label: 'Temperature (0.0 - 2.0):', source: 'temperature'},
    {param: 'max_completion_tokens', label: 'Tokens:', source: 'token'},
];

export const AiSettingsShow = () => {
    const redirect = useRedirect();
    const rd = useRecordContext();

    const navigateToEdit = () => {
        redirect(`/ai/settings/custom/edit`)
    }
    const SystemPrompt = ({ record }) => (
        <Typography style={{ whiteSpace: 'pre-wrap' }}>
            {record.systemPrompt}
        </Typography>
    );

    const PromptTemplate = ({ record }) => (
        <Typography style={{ whiteSpace: 'pre-wrap' }}>
            {record.promptTemplate}
        </Typography>
    );

    const InfoShowTab = () => {
        const record = useRecordContext();
        if (!record) return null;

        const current = (record.models ?? []).find(item => item.id === record.model);
        const supports = current?.supports ?? [];
        // Reasoning models get top_p only with the 'none' effort, as in the backend.
        const isSent = param => supports.includes(param)
            && !(param === 'top_p' && current.efforts.length && record.effort !== 'none');

        return (
            <TabbedShowLayout>
            <Tab label="Details">
                <div>
                    <GradientButton  style={{float: 'right'}} label={'Edit'} onClick={() => navigateToEdit()}  />
                </div>
                <TextField label='OpenAI Model:' source="model"/>
                {MODEL_FIELDS
                    .filter(field => isSent(field.param))
                    .map(field => <TextField key={field.source} label={field.label} source={field.source}/>)}
                <FunctionField label="Store" render={(record) => {
                    return record.store ? 'yes' : 'no';
                }}/>
                <FunctionField label="System Prompt:" render={(record) => {
                    return <SystemPrompt record={record} />;
                }}/>
                <FunctionField label="User Prompt Template:" render={(record) => {
                    return <PromptTemplate record={record} />;
                }}/>
            </Tab>
            </TabbedShowLayout>
        );
    };

    return (
        <>
            <Show actions={<></>}>
                <InfoShowTab />
            </Show>
        </>
    );
};
